<div class="historico-branch" *ngIf="sucursal">
  <!-- Mobile collapsed header -->
  <button
    *ngIf="isCollapse && !isDesktop"
    type="button"
    class="mobile-collapse-header"
    (click)="collapseAction()"
  >
    <div class="collapse-content">
      <div class="branch-title-section">
        <mat-icon class="location-icon" svgIcon="location_on"></mat-icon>
        <span class="collapse-title">{{ sucursal.name }}</span>
      </div>
    </div>
    <mat-icon
      class="expand-arrow"
      [class.rotated]="!isCollapse"
      svgIcon="keyboard_arrow_down"
    ></mat-icon>
  </button>

  <div class="historico-branch__bar" *ngIf="!isCollapse">
    <div class="historico-branch__left">
      <div class="historico-field">
        <span class="historico-field__label">{{
          'HISTORICO_BRANCH.FORM_LABEL' | translate
        }}</span>
        <mat-icon
          *ngIf="icon"
          class="historico-field__trend"
          [class.historico-field__trend--up]="icon === 'arrow_drop_up'"
          [class.historico-field__trend--down]="icon === 'arrow_drop_down'"
          [svgIcon]="icon"
        ></mat-icon>
        <span class="historico-field__value">{{ porcentaje }}</span>
      </div>

      <button
        type="button"
        class="contact-btn"
        [attr.aria-label]="'NAV.MY_RESERVATIONS' | translate"
        (click)="goToGraficas()"
      >
        <mat-icon svgIcon="arrow_forward"></mat-icon>
      </button>
    </div>

    <div class="historico-branch__select">
      <app-branch-select-field></app-branch-select-field>
    </div>

    <div class="historico-branch__contacts">
      <a
        class="contact-btn"
        [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_PHONE' | translate"
        [href]="'tel:' + getBranchPhone()"
      >
        <mat-icon svgIcon="call"></mat-icon>
      </a>
      <a
        class="contact-btn"
        [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_WHATSAPP' | translate"
        target="_blank"
        rel="noopener noreferrer"
        [href]="'https://wa.me/' + getBranchWhatsapp()"
      >
        <i class="fa-brands fa-whatsapp" aria-hidden="true"></i>
      </a>
      <a
        class="contact-btn"
        [matTooltip]="'HISTORICO_BRANCH.TOOLTIP_LOCATION' | translate"
        target="_blank"
        rel="noopener noreferrer"
        [href]="
          'https://www.google.com/maps/search/?api=1&query=' +
          sucursal?.address?.latitude +
          '%2C' +
          sucursal?.address?.longitude
        "
      >
        <mat-icon svgIcon="navigation"></mat-icon>
      </a>
    </div>

    <button
      *ngIf="!isDesktop"
      type="button"
      class="historico-branch__collapse-toggle"
      (click)="collapseAction()"
      aria-label="Colapsar sucursal"
    >
      <mat-icon svgIcon="arrow_drop_up"></mat-icon>
    </button>
  </div>
</div>
